import { useAppConfiguration, useTrackEvent } from '@wkda/funnel-components';
import { getTrustpilotAutoheroConfig } from '../../../constants/carlead/trustpilotAutoheroConfig';
import useScript from '../../appointment/TrustPilot/useScript';

/**
 * TrustpilotAutohero Component
 * Displays Autohero Trustpilot reviews widget with locale-specific configuration
 * Used in CarleadCrossPromoBannerAH component
 *
 * The component loads the Trustpilot script to ensure the widget can initialize
 * even when the main WKDA TrustPilot component is not present on the page.
 * Multiple script loads are safe as the browser handles duplicate script URLs.
 *
 * An overlay anchor tag is used to block hover effects while maintaining
 * click-through functionality to the Autohero Trustpilot profile page.
 */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const TrustpilotAutohero = () => {
  const {
    fullLocale
  } = useAppConfiguration();
  const config = getTrustpilotAutoheroConfig(fullLocale);
  const track = useTrackEvent();
  const {
    trackLandingPageType
  } = useAppConfiguration();

  // Load Trustpilot script - safe to call even if already loaded elsewhere
  useScript('//widget.trustpilot.com/bootstrap/v5/tp.widget.bootstrap.min.js');
  const handleCtaClick = () => {
    track({
      action: 'eventTracking',
      category: trackLandingPageType,
      eventData: {
        category: 'Cross promotion - AH Smart Car Finder',
        action: 'Click',
        label: 'Autohero Trustpilot'
      }
    });
  };
  if (fullLocale === 'sv-SE') {
    return null;
  }
  return /*#__PURE__*/_jsxs("div", {
    className: "trustpilot-autohero-wrapper",
    children: [/*#__PURE__*/_jsx("div", {
      className: "trustpilot-widget d-flex justify-content-center",
      "data-template-id": config.templateId,
      "data-businessunit-id": config.businessUnitId,
      "data-theme": config.theme,
      "data-locale": config.locale,
      "data-style-height": config.height,
      "data-style-width": config.width,
      "data-review-languages": config.reviewLanguages,
      "data-font-family": config.fontFamily
    }), /*#__PURE__*/_jsx("a", {
      href: config.href,
      target: "_blank",
      rel: "noopener noreferrer",
      className: "trustpilot-autohero-overlay",
      "aria-label": "View Autohero reviews on Trustpilot",
      onClick: handleCtaClick
    })]
  });
};
export default TrustpilotAutohero;